/**
 * Loads linked products based on SKU when on a product page.
 */ 
const loadLinkedProducts = () => {
  if (location.pathname.includes('/products/')) {
    const container = document.querySelector('[data-product-id]');
    const productID = Number(container.dataset.productId);
    const currentProduct = window.products.find(product => product.id === productID);
    const leftArrow = document.querySelector('.linked-product-left-arrow');
    const rightArrow = document.querySelector('.linked-product-right-arrow');

    if (!currentProduct || currentProduct.sku == "") return;

    let currentSku = currentProduct.sku.split('-')[0];
    let linkedProducts = [];
    linkedProducts = window.products.filter(product => product.sku?.split('-')[0] === currentSku || product.sku === currentSku);

    if (linkedProducts.length <= 1) return;

    const linkedProductContainer = document.querySelector('[data-linked-products-sku]');
    // const currentColorElem = document.querySelector('[data-current-color]');
    const activeLinked = linkedProducts.find(linked => linked.sku === currentProduct.sku);

    // Insert linked products into the DOM 
    if (linkedProductContainer) {
      linkedProducts.forEach(linked => {
        const title = linked.title.split(' - ');
        linkedProductContainer.insertAdjacentHTML('afterbegin', `
          <a href="${linked.url}" class="${linked === activeLinked ? 'active' : ''} ${!linked.available ? 'unavailable' : ''}">
              <img src="${linked.image}" alt="${linked.title}">
          </a>
          `);
      });

      if (linkedProducts.length > 4){
        leftArrow.removeAttribute('hidden');
        rightArrow.removeAttribute('hidden');
      }

      leftArrow.addEventListener('click', () => {
        linkedProductContainer.scrollLeft -= 100;
      });

      rightArrow.addEventListener('click', () => {
        linkedProductContainer.scrollLeft += 100;
      });
    }

 
    // Add event listeners to linked product color elements

    /*const linkedColorElement = linkedProductContainer.querySelectorAll('[data-color]');
    linkedColorElement.forEach(element => {
      element.addEventListener('mouseover', () => {
        currentColorElem.textContent = element.dataset.color;
      });
      element.addEventListener('mouseleave', () => {
        currentColorElem.textContent = activeLinked?.title.split(' - ')[activeLinked.title.split(' - ').length - 1];
      });
    });*/
  }
};

/**
 * Fetches all products and saves them in sessionStorage.
 */
const fetchAllProducts = async () => {
  let i = 1;
  const urls = Array.from({ length: window.themeVariables.settings.productPages }, (_, i) => `${window.themeVariables.routes.collectionsAll}?view=linked&page=${i + 1}&filter.v.availability=1&filter.v.availability=0`).map(url => fetch(url));

  const responses = await Promise.all(urls);
  const data = await Promise.all(responses.map(res => res.json()));
  const allProducts = data.flat();

  window.products = allProducts;
  sessionStorage.setItem('allProducts', JSON.stringify(allProducts)); // Save in sessionStorage

  console.info('Linked products refetched');
  loadLinkedProducts();
};

// Check if all products are already in sessionStorage, otherwise fetch them
if (!sessionStorage.getItem('allProducts')) {
  fetchAllProducts();
} else {
  window.products = JSON.parse(sessionStorage.getItem('allProducts'));
  loadLinkedProducts();
}